import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

type UpperNavBadge = {
  text: string;
  colorClass: string;
};

export const useBadge = () => {
  const store = useStore();
  const { t } = useI18n();

  const selectedAccount = computed<null | {
    type_name: "System" | "MSP" | "Customer" | "Distributor";
  }>(() => store.getters["authentication/selectedAccount"]);
  const selectedMsp = computed(
    () => store.getters["authentication/selectedMsp"],
  );
  const selectedCustomer = computed(
    () => store.getters["authentication/selectedCustomer"],
  );

  const getBadge = () => {
    if (!selectedAccount.value) {
      return null;
    }
    if (
      selectedAccount.value.type_name === "Customer" ||
      selectedCustomer.value?.uuid
    ) {
      return {
        text: t("tier-customer"),
        colorClass: "tw-bg-nav-badge-customer",
      };
    }
    if (selectedAccount.value.type_name === "MSP" || selectedMsp.value?.uuid) {
      return {
        text: t("tier-msp"),
        colorClass: "tw-bg-nav-badge-msp",
      };
    }
    if (selectedAccount.value.type_name === "System") {
      return {
        text: t("tier-system"),
        colorClass: "tw-bg-nav-badge-system",
      };
    }
    if (selectedAccount.value.type_name === "Distributor") {
      return {
        text: t("tier-distributor"),
        colorClass: "tw-bg-nav-badge-distributor",
      };
    }

    return null;
  };

  const badge: UpperNavBadge | null = getBadge();

  return { badge };
};
